import { Stack } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import badgeMapper, { BadgeId } from "./badgeMapper";

interface GoBadgeGroupProps {
    badgeIds: BadgeId[];
    spacing?: number;
    parentSx?: SxProps<Theme>;
    sx?: SxProps<Theme>;
}

const GoBadgeGroup = ({ badgeIds, spacing = 1, parentSx = {}, sx = {} }: GoBadgeGroupProps) => {
    if (!badgeIds?.length) {
        return null;
    }

    return (
        <Stack direction="row" spacing={spacing} gap="6px" marginBottom="10px" sx={parentSx}>
            {badgeIds.map((id) => {
                const BadgeComponent = badgeMapper[id];
                if (!BadgeComponent) return null;
                return <BadgeComponent key={id} sx={sx} />;
            })}
        </Stack>
    );
};

export default GoBadgeGroup;
